import React from 'react'
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Cell } from 'recharts'
import styles from './MicrositeSourceBreakdown.module.css'

const SOURCE_COLORS = {
    organic: '#1c8a4a',
    direct: '#0369a1',
    referral: '#b8741a',
    social: '#c2786e',
    email: '#6b7280'
}

/**
 * MicrositeSourceBreakdown
 * Horizontal-feel bar chart for traffic source split (organic /
 * direct / referral / social / email), used on MicrositeAnalytics.
 *
 * Usage:
 *   <MicrositeSourceBreakdown data={sourceStats.data} />
 *   // data: [{ groupKey: 'organic', totalViews: 210 }, ...]
 */
const MicrositeSourceBreakdown = ({ data = [] }) => {
    if (!data.length) {
        return <div className={styles.empty}>No traffic source data yet</div>
    }

    const chartData = data.map((d) => ({
        name: d.groupKey,
        views: Number(d.totalViews) || 0
    }))

    return (
        <div className={styles.wrap}>
            <ResponsiveContainer width="100%" height={180}>
                <BarChart data={chartData} layout="vertical" margin={{ top: 0, right: 16, left: 0, bottom: 0 }}>
                    <CartesianGrid horizontal={false} stroke="#eef0f2" />
                    <XAxis type="number" tick={{ fontSize: 11, fill: '#9aa1ac' }} axisLine={false} tickLine={false} />
                    <YAxis
                        type="category"
                        dataKey="name"
                        tick={{ fontSize: 12, fill: '#3a4150', fontWeight: 600 }}
                        axisLine={false}
                        tickLine={false}
                        width={70}
                    />
                    <Tooltip
                        formatter={(value) => [`${value} views`, '']}
                        contentStyle={{ fontSize: 12, borderRadius: 6, border: '1px solid #e6e8eb' }}
                    />
                    <Bar dataKey="views" radius={[0, 4, 4, 0]} maxBarSize={20}>
                        {chartData.map((entry, idx) => (
                            <Cell key={idx} fill={SOURCE_COLORS[entry.name] || '#0369a1'} />
                        ))}
                    </Bar>
                </BarChart>
            </ResponsiveContainer>
        </div>
    )
}

export default MicrositeSourceBreakdown